<template>
  <div>
    <div>
      <div class="d-flex justify-space-between">
        <BaseButton
          :text="`Back to 'Your quote'`"
          flat
          ripple
          class="font-weight-bold d-flex ml-n5"
          icon="mdi-chevron-left"
          color="psdarkgreen"
          small
          @click="backToYourQuotesStep"
        />
        <BaseButton
          :text="$vuetify.breakpoint.lgAndUp ? 'Save &amp; exit' : 'Save'"
          flat
          depressed
          ripple
          class="font-weight-bold px-1 py-3"
          icon="mdi-content-save"
          color="psdarkgreen"
          small
          @click="toggleGlobalSaveAndExitDialog"
        />
      </div>
      <h2 class="font-24 font-lg-28 font-weight-bold primary--text mt-10">
        {{ $vuetify.breakpoint.lgAndUp ? "Your application" : "Application" }}
      </h2>
    </div>

    <ValidationObserver ref="observerFormApplication" v-slot="{ validate }">
      <form @submit.prevent="onSubmit(validate)">
        <h2 class="mt-9 font-20 font-weight-bold black2-color">
          Policy details
        </h2>

        <BaseLabel :text="LABEL_CONSTANTS.BASIS_OF_ADVICE" class="mt-3 mb-2" />
        <BaseSelect
          dense
          v-model="questionBasisOfAdvice.Value"
          :items="basisOfAdviceItems"
          :data-uiid="questionBasisOfAdvice.InterfaceKey"
          :hide-details="false"
          :selectedDefault="LABEL_CONSTANTS.SELECT_DEFAULT_PLACEHOLDER"
          :rules="{
            required: {
              required: true,
              fieldLabel: LABEL_CONSTANTS.BASIS_OF_ADVICE,
            },
          }"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
        />

        <BaseLabel text="Policy start date" class="mt-3 mb-2" />
        <BaseInputDate
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :hide-details="false"
          :rules="questionPolicyStartDateRules"
          :vid="questionPolicyStartDate.InterfaceKey"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          dataUiid="PolicyStartDate"
          v-model="questionPolicyStartDate.Value"
        />

        <BaseLabel
          :text="LABEL_CONSTANTS.DOCUMENT_DELIVERY_PREFERENCE"
          class="mt-3 mb-2"
        />
        <BaseRadio
          v-model="questionDocumentDeliveryPreference.Value"
          pslStyle="button"
          class="pt-3"
          data-uiid="DocumentDeliveryPreferencesRadio"
          :hideDetails="false"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :items="documentDeliveryPreferenceOptions"
        />

        <h2 class="mt-3 font-20 font-weight-bold black2-color">
          Applicant details
        </h2>

        <BaseLabel text="Email address" class="mt-3 mb-2" />
        <BaseInput
          :data-uiid="questionEmailAddress.InterfaceKey"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :hide-details="false"
          :rules="questionEmailAddressRules"
          :vid="questionEmailAddress.InterfaceKey"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          v-model="questionEmailAddress.Value"
        />

        <BaseLabel
          v-if="
            !isShowPropertyDetailsFields &&
            !enteringCorrespondenceAddressManually
          "
          class="mt-3 mb-2"
          text="Correspondence address"
          helpText="Please provide the postcode to be used for correspondence with the applicant. This must be a UK address and should not be a PO Box or Care Of Address."
        ></BaseLabel>
        <BaseAddressLookup
          dataUiid="CorrespondenceAddress"
          manualAddressFormText="Correspondence address"
          :placeholder="
            $vuetify.breakpoint.lgAndUp
              ? 'Start typing your address or postcode...'
              : 'Start typing...'
          "
          manualFormUiid="CorrespondenceAddress"
          id="correspondence-address-lookup"
          @address-selected="
            (response) =>
              getAddressSelected(response, questionCorrespondenceAddress)
          "
          @enter-address-manually="enteringCorrespondenceAddressManually = true"
          @use-address-finder="enteringCorrespondenceAddressManually = false"
          @is-complete-fill-address="
            (value) => (isShowPropertyDetailsFields = value)
          "
          :address="questionCorrespondenceAddress"
          :rules="{
            required: {
              required: true,
              fieldLabel: 'Find your correspondence address',
            },
          }"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          showManualAddressForm
          :hideDetails="false"
          addressSummaryWrapper="mt-3 address-summary__wrapper mb-10"
        />

        <BaseAlert color="doeskin" class="pa-4 pr-6 ma-0">
          <div class="d-flex flex-no-wrap">
            <div class="mr-3">
              <v-icon color="suncrete">mdi-alert</v-icon>
            </div>
            <div>
              <span class="font-weight-bold">Important!</span> To be eligible
              for this policy, you (the person named on the policy certificate)
              must permanently reside in the United Kingdom. Or if insured in
              the name of a limited company, it must be registered with
              Companies House in the United Kingdom.
            </div>
          </div>
        </BaseAlert>

        <BaseLabel text="Your reference (optional)" class="mt-10 mb-2" />
        <BaseInput
          v-model="questionYourRef.Value"
          :vid="questionYourRef.InterfaceKey"
          :data-uiid="questionYourRef.InterfaceKey"
          :hide-details="false"
          :rules="questionYourRefRules"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
        />

        <BaseButton
          color="psorange"
          class="mt-4 font-weight-bold continue-button primary--text"
          height="60"
          rounded
          type="submit"
          :text="
            $vuetify.breakpoint.lgAndUp ? 'CONTINUE TO PAYMENT' : 'CONTINUE'
          "
          :fontSize="'font-20'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '390px' : '100%'"
        />
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { EventBus } from "@/common/eventbus.js";
import { scrollTop, tryGoToNextStep } from "@/common/utils";
import { addressSelected } from "@/common/addresses";
import { ValidationObserver } from "vee-validate";
import { mapActions, mapState } from "vuex";
import { ROUTE_NAME } from "@/constants/route.constants";
import {
  QUESTIONS_MODULE,
  APPLICATION_MODULE,
} from "@/store/types/module-types";

import BaseButton from "@/components/BaseComponents/BaseButton.vue";
import BaseLabel from "@/components/BaseComponents/BaseLabel.vue";
import BaseInput from "@/components/BaseComponents/BaseInput.vue";
import * as ERROR_MESSAGES from "@/constants/message.constants.js";
import * as LABEL_CONSTANTS from "@/constants/label.constants";
import {
  DATE_REGEX,
  EMAIL_REGEX,
  USER_REF_EXCLUDE_ANGLE_BRACKETS_REGEX,
} from "@/constants/regex-patterns.constants";
import { addFieldLabel } from "@/common/utils";
import { QuestionStore } from "@/store/store";
import {
  BASIS_OF_ADVICE,
  RP_DOCUMENT_DELIVERY_PREFERENCE_OPTIONS,
  setItemDataUiids,
} from "@/constants/component.constants";
import BaseSelect from "@/components/BaseComponents/BaseSelect.vue";
import BaseInputDate from "@/components/BaseComponents/BaseInputDate.vue";
import BaseAddressLookup from "@/components/BaseComponents/BaseAddressLookup.vue";
import BaseAlert from "@/components/BaseComponents/BaseAlert.vue";
import BaseRadio from "@/components/BaseComponents/BaseRadio.vue";

export default {
  name: "YourApplicationPage",
  components: {
    BaseButton,
    ValidationObserver,
    BaseLabel,
    BaseSelect,
    BaseInputDate,
    BaseInput,
    BaseAddressLookup,
    BaseAlert,
    BaseRadio,
  },
  data() {
    return {
      questionBasisOfAdvice: {},
      questionPolicyStartDate: {},
      questionDocumentDeliveryPreference: {},
      questionCorrespondenceAddress: {},
      questionEmailAddress: {},
      questionYourRef: {},

      enteringCorrespondenceAddressManually: false,
      isShowPropertyDetailsFields: false,

      USER_REF_EXCLUDE_ANGLE_BRACKETS_REGEX,
      ERROR_MESSAGES,
      LABEL_CONSTANTS,

      questionPolicyStartDateRules: addFieldLabel(
        {
          required: {},
          date_valid: {
            errorMessageTemplate: ERROR_MESSAGES.ERROR_INVALID,
          },
          regex: {
            errorMessageTemplate: ERROR_MESSAGES.ERROR_INVALID,
            pattern: DATE_REGEX,
          },
          between_now_and: {
            future: QuestionStore.getters("getQuoteExpiryDate"),
          },
        },
        "Policy start date"
      ),

      questionEmailAddressRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          max: {
            length: 50,
            errorMessageTemplate: ERROR_MESSAGES.ERROR_MSG_MAX_CHARACTER,
          },
          regex: {
            pattern: EMAIL_REGEX,
            customMessage: ERROR_MESSAGES.ERROR_INVALID_EMAIL_ADDRESS,
          },
        },
        "Email address"
      ),

      questionYourRefRules: addFieldLabel(
        {
          max: {
            length: 40,
            errorMessageTemplate: ERROR_MESSAGES.ERROR_MSG_MAX_CHARACTER,
          },
          regex: {
            pattern: USER_REF_EXCLUDE_ANGLE_BRACKETS_REGEX,
            customMessage: ERROR_MESSAGES.ERROR_MSG_USER_REF,
          },
        },
        "Your reference"
      ),
    };
  },
  computed: {
    ...mapState(APPLICATION_MODULE, {
      applicationQuestionMap: "questionMap",
    }),
    ...mapState(QUESTIONS_MODULE, {
      userReference: "userReference",
      restoringLastStep: "restoringLastStep",
      questionsQuestionMap: "questionMap",
    }),

    basisOfAdviceItems() {
      return setItemDataUiids("BasisOfAdvice", BASIS_OF_ADVICE);
    },

    documentDeliveryPreferenceOptions() {
      return setItemDataUiids(
        this.questionDocumentDeliveryPreference.InterfaceKey,
        RP_DOCUMENT_DELIVERY_PREFERENCE_OPTIONS
      );
    },
  },
  beforeMount() {
    this.onSetupAndLoadSavedData();
    scrollTop();
  },
  mounted() {
    this.setCurrentRefObserverForm(this.$refs.observerFormApplication);

    if (!this.restoringLastStep) {
      return;
    }

    setTimeout(async () => {
      tryGoToNextStep(
        this.$refs.observerFormApplication,
        async (form) => await form.validate(),
        ROUTE_NAME.RENT_PROTECTION.B2B.PAYMENT
      );
    }, 0);
  },
  watch: {
    "questionYourRef.Value"(value) {
      this.setUserReference(value);
    },
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, [
      "refreshSessionAndNextStep",
      "toggleGlobalSaveAndExitDialog",
      "setCurrentRefObserverForm",
      "setUserReference",
    ]),

    backToYourQuotesStep() {
      this.$router.push({
        name: ROUTE_NAME.RENT_PROTECTION.B2B.QUOTATION_RESULT,
      });
    },

    onSetupAndLoadSavedData() {
      this.questionBasisOfAdvice = this.applicationQuestionMap["BasisOfAdvice"];
      this.questionPolicyStartDate =
        this.applicationQuestionMap["PolicyStartDate"];
      if (!this.questionPolicyStartDate.Value) {
        this.questionPolicyStartDate.Value =
          this.questionsQuestionMap["PolicyStartDate"].Value;
      }
      this.questionDocumentDeliveryPreference =
        this.applicationQuestionMap["DocumentDeliveryPreference"];
      this.questionCorrespondenceAddress = {
        PostCode: this.applicationQuestionMap["CorrespondencePostCode"],
        Street: this.applicationQuestionMap["CorrespondenceStreet"],
        District: this.applicationQuestionMap["CorrespondenceDistrict"],
        Town: this.applicationQuestionMap["CorrespondenceTown"],
        County: this.applicationQuestionMap["CorrespondenceCounty"],
      };
      if (this.questionCorrespondenceAddress.PostCode.Value) {
        this.isShowPropertyDetailsFields = true;
      }
      this.questionEmailAddress =
        this.applicationQuestionMap["Applicant1EmailAddress"];
      this.questionYourRef = this.applicationQuestionMap["YourRef"];
      if (this.userReference) {
        this.questionYourRef.Value = this.userReference;
      }
    },

    getAddressSelected(response, address) {
      addressSelected(response, address);
    },

    async onSubmit(validate) {
      const isFormValid = await validate();

      if (!isFormValid) {
        EventBus.$emit("validation-error", "Validation error occurred");

        return;
      }

      this.refreshSessionAndNextStep(ROUTE_NAME.RENT_PROTECTION.B2B.PAYMENT);
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-input--radio-group__input) {
  display: grid;
  gap: 16px;
  grid-template-columns: auto auto;

  .v-btn {
    margin: 0 !important;
    min-width: none;
    width: auto !important;
  }
}

:deep(.find-property) {
  .v-input__append-inner {
    margin: auto 0 !important;
  }
}

@media screen and (min-width: $grid-breakpoints-md) {
  :deep(.v-input--radio-group__input) {
    grid-template-columns: min-content min-content;

    .v-btn {
      min-width: 145px;
    }
  }
}
</style>
